import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    // { key: 'upt_uraian', sortable: true, label: 'UPT' },
    // { key: 'kanwil_uraian', sortable: true, label: 'KANWIL' },
    // { key: 'direktorat_uraian', sortable: true, label: 'Direktorat' },
    { key: 'kategori_tiket', sortable: true, label: 'Kategori' },
    { key: 'sub_kategori_tiket', sortable: true, label: 'Jenis Pekerjaan' },
    { key: 'jumlah', sortable: true, label: 'Jumlah' },
    // { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const searchQueryRangeDate = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const tahunFilter = ref(null)
  const bulanFilter = ref(null)
  const kanwilFilter = ref(null)
  const kategoriFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([
    currentPage,
    perPage,
    searchQuery,
    searchQueryRangeDate,
    tahunFilter,
    bulanFilter,
    kanwilFilter,
    kategoriFilter,
    statusFilter,
  ], () => {
    refetchData()
  })

  const fetchDatas = (ctx, callback) => {
    store
      .dispatch('laporan-status/fetchDatas', {
        q: searchQuery.value,
        r: searchQueryRangeDate.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        tahun_filter: tahunFilter.value,
        bulan_filter: bulanFilter.value,
        kanwil_filter: kanwilFilter.value,
        kategori_filter: kategoriFilter.value,
        status_filter: statusFilter.value,
      })
    // console.log(newSearch.value)
      .then(response => {
        const { data, total } = response.data

        callback(data)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Tidak dapat mengambil data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchDatas,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    searchQueryRangeDate,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    tahunFilter,
    bulanFilter,
    kanwilFilter,
    kategoriFilter,
    statusFilter,
  }
}
